import { CbhFeatureFlag } from "../FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "../FeatureFlags/constants";
import { useCbhFlag } from "../FeatureFlags/useCbhFlag";

export function useLiveActivitiesConfig() {
  return useCbhFlag(CbhFeatureFlag.LIVE_ACTIVITIES_CONFIG, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.LIVE_ACTIVITIES_CONFIG],
  });
}
